export default "__VITE_ASSET__Dm$xhzzD__"